module.exports = __webpack_public_path__ + "static/media/sf_attraction_2.4b7d31ea.jpg";